import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select
} from '@mui/material';
import { InputField, CtaButton } from './SettingsUI';
import type { SubjectItem } from '../types';

interface SubjectModalProps {
  open: boolean;
  onClose: () => void;
  newSubjectName: string;
  setNewSubjectName: (v: string) => void;
  newSubjectType: 'topic' | 'industry';
  setNewSubjectType: (v: 'topic' | 'industry') => void;
  onAdd: (subject: SubjectItem) => void;
}

export function SubjectModal({
  open,
  onClose,
  newSubjectName,
  setNewSubjectName,
  newSubjectType,
  setNewSubjectType,
  onAdd
}: SubjectModalProps) {
  const handleAdd = () => {
    onAdd({ name: newSubjectName, type: newSubjectType });
    setNewSubjectName('');
    setNewSubjectType('topic');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          background: '#1C1C1C',
          width: 380,
          p: 3,
          borderRadius: 2,
          border: '1px solid #2A2A2A'
        }
      }}
    >
      <DialogTitle sx={{ color: '#FDFDFD', fontSize: 16, fontWeight: 700 }}>
        Add a new subject
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <InputField
          label="Subject Name"
          placeholder="Enter subject name"
          value={newSubjectName}
          onChange={setNewSubjectName}
        />
        <Select
          value={newSubjectType}
          onChange={(e) => setNewSubjectType(e.target.value as 'topic' | 'industry')}
          fullWidth
          size="small"
          sx={{
            background: 'rgba(0,0,0,0.7)',
            outline: '1px solid #868686',
            color: '#fff',
            borderRadius: '6px',
            '& .MuiSelect-icon': { color: '#fff' }
          }}
          MenuProps={{ PaperProps: { sx: { bgcolor: '#000', color: '#fff' } } }}
        >
          <MenuItem value="topic">Topic</MenuItem>
          <MenuItem value="industry">Industry</MenuItem>
        </Select>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <CtaButton onClick={handleAdd} disabled={!newSubjectName.trim()}>
          Add Subject
        </CtaButton>
      </DialogActions>
    </Dialog>
  );
}
